import {createDragDropManager} from 'dnd-core';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {DndProvider} from 'react-dnd';

const manager = createDragDropManager(HTML5Backend);

const DragAndDropContext = Component => {
  const WithDragAndDropContext = props => (
    <DndProvider manager={manager}>
      <Component {...props}/>
    </DndProvider>
  );

  WithDragAndDropContext.displayName = `DragAndDropContext(${Component.displayName || Component.name || 'Component'})`;

  return WithDragAndDropContext;
};

export default DragAndDropContext;
